export default import.meta.ROLLUP_FILE_URL_Uzr8fzBjdJgRS_KbGEYplQ